import { MARKETING_SMS_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const MarketingSms = ObjectDefinitionRecord({
  hasAccess: (__isUngated, hasScope) => hasScope('sms-view'),
  objectTypeId: MARKETING_SMS_TYPE_ID,
  referenceObjectType: 'MARKETING_SMS_PROPERTIES'
});
export default MarketingSms;